import type { CardSummary } from './card-summary'

export type CardsPage = {
  count: number,
  page: number,
  items: CardSummary[]
}
const buildCardsPage = (count: number = 99, page: number = 3, items: Array = []): CardsPage => ({
  count,
  page,
  items
})
export {
  buildCardsPage
}



// WEBPACK FOOTER //
// ./src/types/cards-page.js